import { useEffect } from "react";
import Switch from "components/atoms/Switch/Switch";
import { useFormContext, useWatch } from "react-hook-form";
import { customSettingField } from "../../customSettingFields";

interface CustomSettingsProps {
  fields: customSettingField[];
  fieldParentKey: "rate" | "request" | "shipment" | "billing";
}

function CustomSettings({ fields, fieldParentKey }: CustomSettingsProps) {
  const { setValue } = useFormContext();
  const customValues = useWatch({ name: `custom.${fieldParentKey}` });

  useEffect(() => {
    if (customValues) return;
    fields.forEach((input, index) => {
      setValue(`custom.${fieldParentKey}.${index}`, { key: input.key });
    });
  }, [customValues]);

  return (
    <>
      <div className="font-weight-bold mt-3 mb-3">Allow team messages for:</div>
      <div>
        {fields.map(({ key, label }: customSettingField, index) => (
          <Switch
            key={key}
            label={label}
            name={`custom.${fieldParentKey}.${index}.value`}
            onChange={(checked) => {
              setValue(`custom.${fieldParentKey}.${index}`, { key, value: checked });
            }}
          />
        ))}
      </div>
    </>
  );
}

export default CustomSettings;
